import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useRef } from 'react';
import ReactModal from 'react-modal';
import { Transition } from 'react-transition-group';
import Theme from '../../styles/theme';
import { Card } from '..';
import styled from '../../styles/styled';
import { IconButton } from '../buttons';
export const Modal = ({ isOpen, className, closeDelayMS = 0, closeOnOverlayClick, closeOnEscape = true, contentStyle = {}, onOpen = () => { }, onClose = () => { }, children, renderOnlyChildren = false, variant = 'info', hideCloseButton, cardProps, overlayColor = 'darkBlueSemiOpaque', mobile, inCall, styleOverride = { overlay: null, content: null, card: null }, }) => {
    const nodeRef = useRef(null);
    const transitionStyles = {
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
        exited: { opacity: 0 },
    };
    const handleClose = useCallback((e) => {
        e?.preventDefault();
        onClose();
    }, [onClose]);
    return (_jsx(Transition, { nodeRef: nodeRef, in: isOpen, timeout: closeDelayMS, children: state => {
            return (_jsxs(ReactModal, { isOpen: isOpen, appElement: document.body, shouldCloseOnEsc: closeOnEscape, shouldCloseOnOverlayClick: closeOnOverlayClick, onRequestClose: onClose, onAfterOpen: onOpen, className: className || '', closeTimeoutMS: closeDelayMS, style: {
                    overlay: {
                        ...defaultOverlayStyle,
                        background: Theme.colors[overlayColor],
                        opacity: transitionStyles[state].opacity,
                        transition: `opacity ${closeDelayMS}ms ease-in-out`,
                        zIndex: inCall ? Theme.layers.inCall.modal : Theme.layers.modal,
                        ...styleOverride.overlay,
                    },
                    content: {
                        ...defaultContentStyle,
                        ...(contentStyle || {}),
                        opacity: transitionStyles[state].opacity,
                        transition: `opacity ${closeDelayMS}ms ease-in-out`,
                        zIndex: inCall ? Theme.layers.inCall.modal : Theme.layers.modal,
                        ...styleOverride.content,
                    },
                }, children: [!renderOnlyChildren && (_jsxs(Card, { decoratorPosition: !cardProps ? 'side' : undefined, variant: !cardProps ? variant : undefined, ...cardProps, style: {
                            padding: '36px',
                            maxWidth: mobile ? '366px' : '',
                            zIndex: inCall ? Theme.layers.inCall.modal : Theme.layers.modal,
                            ...styleOverride.card,
                        }, children: [children, !hideCloseButton && (_jsx(CloseContainer, { "data-testid": "close-form-button", variant: variant, children: _jsx(IconButton, { iconName: 'CloseIcon', size: "medium", label: "close", onClick: handleClose, background: variant === 'info' ? 'azure' : 'transparent', fill: variant === 'info' ? 'white' : undefined }) }))] })), renderOnlyChildren && children] }));
        } }));
};
Modal.displayName = 'Modal';
const defaultOverlayStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    overflow: 'auto',
};
const defaultContentStyle = {
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'transparent',
    border: 'none',
    inset: '0px',
};
export const CloseContainer = styled.div(({ variant }) => ({
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    right: variant === 'info' ? '32px' : '12px',
    top: variant === 'info' ? '40px' : '12px',
}));
//# sourceMappingURL=modal.js.map